import { getKeyboardFocusableElements, getElementFromEvent, storageAvailable } from '../utils';

class NewsletterModal {
	constructor(el) {
		this.el = el;
		this.form = this.el.querySelector('[data-newsletter-modal-form]');
		this.text = this.el.querySelector('[data-newsletter-text]');
		this.timeout = parseInt(this.el.dataset.timeout, 10);
		this.previouslyFocused = null;

		this.closeButton = this.el.querySelector('[data-newsletter-modal-close]');
		this.closeButton.addEventListener('click', (e) => {
			this.closeModal();
		});

		// Event listeners
		this.boundHandleKeys = this.handleKeys.bind(this);
		// this.el.addEventListener('submit', this.submit.bind(this));

		this.el.addEventListener('click', (e) => {
			const bd = getElementFromEvent(e, '[data-newsletter-modal-backdrop]');

			if (bd) {
				this.closeModal();
				return;
			}
		});

		// Automatically open modal
		if(this.timeout||this.timeout===0) { // only if timeout is set
			setTimeout(() => {
				if (!storageAvailable('localStorage')) {
					return;
				}

				const shown = localStorage.getItem('newsletterModal');

				if (shown) {
					return;
				}

				this.openModal();
			}, this.timeout * 1000);
		}
	}


	handleKeys(e) {
		if (e.key === 'Escape') {
			this.closeModal();
		}

		if (e.key === 'Tab') {
			this.tabFocus(e);
		}
	}

	tabFocus(e) {
		if (!this.open) {
			return;
		}

		const focusableElements = getKeyboardFocusableElements(this.el);
		const firstFocusableElement = focusableElements[0];
		const lastFocusableElement = focusableElements[focusableElements.length - 1];

		if (e.shiftKey) {
			if (document.activeElement === firstFocusableElement) {
				lastFocusableElement.focus();
				e.preventDefault();
			}
		} else {
			if (document.activeElement === lastFocusableElement) {
				firstFocusableElement.focus();
				e.preventDefault();
			}
		}
	}

	get open() {
		return this.el.classList.contains('is-active');
	}

	openModal() {
		if (this.open) {
			return;
		}

		if (storageAvailable('localStorage')) {
			localStorage.setItem('newsletterModal', true);
		}

		document.addEventListener('keydown', this.boundHandleKeys);

		this.previouslyFocused = document.activeElement;

		this.el.classList.add('is-active');

		const focusableElements = getKeyboardFocusableElements(this.el);

		if (focusableElements.length) {
			focusableElements[0].focus();
		}
	}

	closeModal() {
		if (!this.open) {
			return;
		}

		document.removeEventListener('keydown', this.boundHandleKeys);

		this.el.classList.remove('is-active');

		if (this.previouslyFocused && this.previouslyFocused.focus) {
			this.previouslyFocused.focus();
		}
	}

	// submit(e) {
	// 	e.preventDefault();

	// 	if (this.isSubmitting) {
	// 		return;
	// 	}

	// 	this.isSubmitting = true;
	// 	this.text.innerHTML = '';

	// 	fetch(this.form.action, {
	// 		method: 'POST',
	// 		body: new FormData(this.form),
	// 	})
	// 		.then((response) => response.json())
	// 		.then((data) => this.displaySuccess(data))
	// 		.catch((error) => this.displayFailure(error))
	// 		.finally(() => (this.isSubmitting = false));
	// }

	// displaySuccess(data) {
	// 	if (!data.success) {
	// 		this.displayFailure(data.data.message);
	// 		return;
	// 	}

	// 	this.text.innerHTML = `<p>${data.data.message}</p>`;

	// 	this.form.reset();
	// }

	// displayFailure(error) {
	// 	if (error.includes('is already a list member')) {
	// 		this.text.innerHTML = '<p>You are already subscribed to the newsletter!</p>';
	// 	} else {
	// 		this.text.innerHTML = '<p>Something went wrong</p>';
	// 	}
	// }
}

export default class Newsletter {
	constructor() {
		this.modal = new NewsletterModal(document.querySelector('[data-newsletter-modal]'));

		document.addEventListener('click', (e) => {
			if (!e.target) {
				return;
			}

			const link = e.target?.closest('[data-open-newsletter-modal]');

			if (!link) {
				return;
			}

			e.preventDefault();
			this.modal.openModal();
		});
	}
}
